export const COLUMN_MAX_LIMIT = 30;
export const PINNED_COLUMS_NAMES = ['id'];
export const coupledColumsInfo = {
  childToParent: { 60: 59, 61: 59 },
  parentNames: {
    59: 'spaces.template.fields.categoriesParentTitle',
  },
};
export const CUSTOM_COLUMN_PREFIX = '$CustValues$';
